<div class="d-flex justify-content-between">
    <div class="font-5 fw-medium w-100 d-flex align-items-center clip3 position-relative me-2 user-card primary-text primary-border corner p-2">Property</div>
    <div class="font-5 fw-semibold w-100 d-flex align-items-center clip3 position-relative me-2 user-card primary-text primary-border corner p-2">Value</div>
</div>
